import { getNominative } from '../../../../common/utils'
import { Document } from '@lmc/ts-common'
import _ from 'lodash'

export const MODAL_ID = 'documentModal'

export const getNoDocumentsMessage = (preferredPeopleNominative: string) =>
  `You haven't added any documents for this ${getNominative(
    preferredPeopleNominative,
    'resident'
  )}`

export const getSupportSummary = (carePlanNominative: string) =>
  `Add documents (${getNominative(
    carePlanNominative,
    'Care Plans'
  )}, assessment forms etc.) so they're viewable here and on the Carer App.`

export const getSupportSummarySeniors = (carePlanNominative: string) =>
  `Admins can add documents (${getNominative(
    carePlanNominative,
    'Care Plans'
  )}, assessment forms etc.) so they're viewable here and on the Carer App.`

export const SUPPORT_ARTICLE =
  'https://support.logmycare.co.uk/the-care-office/finishing-your-essential-setup/how-do-i-upload-a-document-to-a-residents-profile'

export const groupDocuments = (
  documents: Document[],
  carePlanNominative: string
) => {
  type DocumentExtended = Document & { categoryName: string }
  const groupedDocs: any = _(documents)
    .filter((doc) => !doc.attachedToCarePlan)
    .map((document: DocumentExtended) => ({
      ...document,
      categoryName: document.categoryName || 'Other',
    }))
    .sortBy((d) =>
      (document as unknown as Document).attachedToCarePlan
        ? 'ZZ'
        : (d as unknown as DocumentExtended).categoryName
    )
    .groupBy('categoryName')
    .value()

  const carePlanTitle = `Attached to ${getNominative(
    carePlanNominative,
    'Care Plans'
  )}`
  const carePlanDocs = _(documents)
    .filter(
      (doc) => (doc as { attachedToCarePlan: boolean }).attachedToCarePlan
    )
    .map((document) => ({
      ...document,
      categoryName: carePlanTitle,
    }))
    .value()

  if (carePlanDocs.length) {
    groupedDocs[carePlanTitle] = carePlanDocs
  }

  return {
    groupedDocs,
    hasDocuments: !!Object.keys(groupedDocs).length,
  }
}
